import { dashboardRoutes } from "./config/dashboardRoutes";
import { guestRoutes } from "./config/guestRoutes";
import { signaturesRoutes } from "./config/signaturesRoutes";
import { miscellanousRoutes } from "./config/miscellanousRoutes";

export const routes = [
    dashboardRoutes,
    signaturesRoutes,
    miscellanousRoutes,
    guestRoutes,
];
